<template>
    <section id="home" class="back z-1 position-relative">
        <div class="row vh-100 g-0 sticky-top">
            <div class="content col-12 d-flex flex-column justify-content-between z-1">
                <div class="flex-fill d-flex flex-column justify-content-center position-relative">
                    <div class="p-2 position-absolute col-12">
                        <h3 ref="text" class="stoke-text display-3 fw-medium">{{ home_text }}</h3>
                    </div>
					<div class="position-absolute bottom-0 start-50 translate-middle my-5">
						<a href="https://firebasestorage.googleapis.com/v0/b/portfolio-60643.firebasestorage.app/o/Rezaar_Osman_Resume%20(2).pdf?alt=media&token=b646c34d-9a4f-4e29-9659-bb47744cd1d4" target="_blank" class="btn p-3 rounded-5 fw-light btn-outline-light fw-medium">
							Curriculum Vitae
						</a>
					</div>
                </div>
            </div>
        </div>
        <div ref="home" index="0" class="row vh-100 w-100 g-0 apply-scroll-snap position-absolute top-0 start-0">
            <!-- <span class="text-dark">Hi, I'm Rezaar</span> -->
        </div>
        <div ref="home2" index="1" class="row vh-100 bg-white g-0 apply-scroll-snap">
            <!-- <span class="text-dark">Im a Fullstack Developer</span> -->
        </div>
        <div ref="home3" index="2" class="row vh-100 bg-dark g-0 apply-scroll-snap">
            <!-- <span class="text-white">Im an aspiring Software Engineer</span> -->
        </div>
    </section>
</template>
<script>
export default {
    name: 'HomeView',
    data(){
        return {
            home_anim: false,
            home_texts: [
                "Hi, I'm Rezaar.",
                "I'am a Full-stack Developer",
                "I'm an aspiring Software Developer"
            ],
            home_text: null
        }
    },
    mounted(){
        this.$nextTick(()=>{
            let home = this.$refs.home;
            let home2 = this.$refs.home2;
            let home3 = this.$refs.home3;

            [home, home2, home3].forEach( (section) => {
                let observer = new IntersectionObserver( this.handleHome, {
                    root: null,
                    rootMargin: '0px',
                    threshold: 0.5
                } )
                observer.observe(section);
            });
        })
    },
    components: {
    },
    methods: {
        handleHome(event){
            let home = this.$refs.home;
            let home2 = this.$refs.home2;
            let home3 = this.$refs.home3;
            let text = this.$refs.text;

            let _home = [home, home2, home3];

            event.forEach( entry => {
                let index = +entry.target.getAttribute('index');
                if( entry.isIntersecting ){
                    this.home_text = this.home_texts[ index ];
                    if( index == 1 ){
                        text.style['-webkit-text-stroke'] = '1px black';
                    } else {
                        text.style['-webkit-text-stroke'] = '1px white';
                    }
                }
            } )
        }
    }
}
</script>
<style>
.back {
    height: 300vh;
}
.view {
	/* background-color: rgb(19,22,26); */
    scroll-snap-align: center;
}
.stoke-text {
    -webkit-text-stroke: 1px white;
    font-family: Arial, Helvetica, sans-serif;
    color: transparent;
    transition: 500ms;
}
.scroll-snap {
    overflow-y: scroll;
    scroll-snap-type: y mandatory;
}
.apply-scroll-snap {
    scroll-snap-align: start;
}

.moveLeft {
    animation-name: moveLeft;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    -webkit-text-stroke: 2px black;

}
.cv-btn {
	filter: invert(100%);
}

@keyframes moveLeft {
    from {
        transform: translateX(0%);
    }
    to {
        transform: translateX(0%);
    }
}
</style>
